var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticClass:"select",attrs:{"id":"attnSelectorInput","value":_vm.value,"placeholder":_vm.$t('shared.pleaseSelectATTN'),"disabled":_vm.disabled},on:{"change":function($event){_vm.$emit('input', $event)}}},_vm._l((_vm.attns),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55fc794f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/app/shared/components/AttnSelector.vue
// module id = TW/N
// module chunks = 1